// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--HIM03","aside":"_7a3fb80146--aside--UKozP","call":"_7a3fb80146--call--Oax3f"};